/** Copy of the stockAgeing page (Operations), ported from VentaHub. */
export const stockAgeing = {
  title: 'Stock ageing',
  description:
    'How long each SKU’s stock has been in the warehouse, dated from the vendor invoice that received it into its box.',
  chooseTitle: 'Choose a warehouse',
  chooseHint: 'Stock is aged one warehouse at a time.',
  empty: 'No stock to show',
  emptyHint: 'This warehouse holds no stock that matches these filters.',
  open: 'Show the boxes for {{code}}',
  export: 'Download as Excel',
  exporting: 'Preparing…',
  // The saved file's name.
  exportName: 'Stock ageing - {{warehouse}}.xlsx',
  filters: {
    warehouse: 'Warehouse',
    choose: 'Choose…',
    text: 'SKU code or name',
  },
  columns: {
    sku: 'SKU',
    total: 'Units',
  },
  bands: {
    age_0_30: '0–30 days',
    age_31_60: '31–60 days',
    age_61_90: '61–90 days',
    age_91_180: '91–180 days',
    age_181_270: '181–270 days',
    age_270_plus: 'Over 270 days',
    age_pre_migration: 'Before cut-over',
    age_unknown: 'No receipt',
  },
  coverage: {
    label: 'How much stock can be dated',
    headline: '{{percent}} of stock can be dated: {{dated}} of {{total}} units.',
    detail:
      '{{preMigration}} units came in before the OpsCentral cut-over, so their age is not known. {{unknown}} units have no receipt: enter the missing vendor invoice to date them.',
  },
  status: {
    dated: 'Dated',
    pre_migration: 'Before cut-over',
    no_receipt: 'No receipt',
  },
  boxes: {
    title: 'Boxes holding {{code}}',
    titleAny: 'Boxes',
    description:
      'Each box, with the vendor invoice that dated it. Oldest first; boxes without an age come last.',
    empty: 'No boxes hold this SKU.',
    box: 'Box',
    units: 'Units',
    received: 'Received',
    age: 'Age',
    days_one: '{{count}} day',
    days_other: '{{count}} days',
  },
} as const
